import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import * as S from '../styles'
import { getErrorTitle } from '../utils'
import { ErrorItem } from './types'

type BaseErrorProps = {
  error: ErrorItem
  titleKey?: string
  title?: string
}

export const BaseError = ({ error, titleKey, title }: BaseErrorProps) => {
  let displayTitle: string
  if (title) {
    displayTitle = title
  } else if (error.reason) {
    displayTitle = error.reason
  } else if (titleKey) {
    // @ts-expect-error: i18next t() accepts string keys but TypeScript types are strict
    displayTitle = t(titleKey) as string
  } else {
    displayTitle = getErrorTitle(error.code)
  }

  return (
    <Alert variant="critical">
      <S.BaseErrorContent>
        <S.BaseErrorHeader>
          <span>{displayTitle}</span>
        </S.BaseErrorHeader>

        {error.field && (
          <S.BaseErrorField>
            <S.BaseErrorFieldLabel>
              {t('rm:externalCampaignMetrics.form.error.field')}:
            </S.BaseErrorFieldLabel>{' '}
            {error.field}
          </S.BaseErrorField>
        )}

        {((error.lines && error.lines.length > 0) ||
          (error.line !== undefined && error.line > 0)) && (
          <S.BaseErrorField>
            <S.BaseErrorFieldLabel>
              {t('rm:externalCampaignMetrics.form.error.lines')}:
            </S.BaseErrorFieldLabel>{' '}
            {error.lines && error.lines.length > 0
              ? error.lines.join(', ')
              : error.line}
          </S.BaseErrorField>
        )}
      </S.BaseErrorContent>
    </Alert>
  )
}
